<div class="form-group ml-3" style="float: left">
    <label for="exampleFormControlSelect1">{{ 'page.serviceprovider' | translate }}</label>
    <!-- <select class="form-control" (ngModel)="serviceproviderList" name="serviceprovider" id="exampleFormControlSelect1" (ngModelChange)="selectProvider($event)">
        <option disabled hidden value="undefined" selected>Service provider</option>
        <option value="" selected>All</option>
        <option *ngFor="let serviceprovider of serviceproviderList" [ngValue]="serviceprovider">{{serviceprovider.ownerName}}
        </option>
    </select> -->
    <div class="input-icon" *ngIf="serviceproviderList">
        <div ngbDropdown class="d-inline-block dropdown">
            <button class="btn btn-custome ellipsis-css-service-provider-filter" id="dropdownBasic1" ngbDropdownToggle>
                {{selectedProvider
                ?(isStaffLog?selectedProvider.companyName:selectedProvider.companyName)
                : ('page.selectserviceprovider' | translate) }}
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic1" *ngIf="showDropdown">
                <button class="dropdown-item" *ngFor="let item of serviceproviderList" (click)="selectProvider(item)">

                    <span>{{isStaffLog?item.companyName:item.companyName}}</span>
                </button>
            </div>
        </div>
    </div>
</div>